import React, {Component, Suspense} from 'react';
import {BrowserRouter, Route, Navigate, Routes} from 'react-router-dom';
import '../static/css/common.less';
import Loading from "../common/component/loading";

const Home = React.lazy(()=>import("./home"));
const Contact = React.lazy(()=>import("./contact"));
const Privacy = React.lazy(()=>import("./privacy"));
const Disclaimer = React.lazy(()=>import("./disclaimer"));
const Business = React.lazy(()=>import("./business"));
const Game = React.lazy(()=>import("./game"));
const Result = React.lazy(()=>import("./result"));
const HowPlay = React.lazy(()=>import("./howPlay"));
const About = React.lazy(()=>import("./about"));
const Keno = React.lazy(()=>import("./keno"));
const Login = React.lazy(()=>import("./login"));
const Register = React.lazy(()=>import("./register"));
const PlayKeno = React.lazy(() => import("./playKeno"));
const PlayOntarioKeno = React.lazy(() => import("./playOntarioKeno"));

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
    }
    render() {
        return (
            <Suspense fallback={<Loading />}>
                <BrowserRouter>
                    <Routes>
                        <Route exact path="/" element={<Home />} />
                        <Route exact path="/result" element={<Result />} />
                        <Route exact path="/howPlay" element={<HowPlay />} />
                        <Route exact path="/about" element={<About />} />
                        <Route exact path="/contact" element={<Contact />} />
                        <Route exact path="/privacy" element={<Privacy />} />
                        <Route exact path="/disclaimer" element={<Disclaimer />} />
                        <Route exact path="/business" element={<Business />} />
                        <Route exact path="/game/keno" element={<Game />} />
                        <Route exact path="/keno" element={<Keno />} />
                        <Route exact path="/login" element={<Login />} />
                        <Route exact path="/register" element={<Register />} />
                        <Route exact path="/play/keno" element={<PlayKeno />} />
                        <Route
                            exact
                            path="/play/ontario-keno"
                            element={<PlayOntarioKeno />}
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </Suspense>
        );
    }
}

export default App;

